import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SVGIcon from '~/components/ui/Icons/SVGIcon';
import { useLanguageParam } from '~/config/i18n';
import mixpanelTrack from '~/hooks/useMixPanel';

const OfficeDescription = ({
  descriptions,
  extraClasses = '',
}: {
  descriptions: { en: string; fr: string };
  extraClasses?: string;
}) => {
  const lang = useLanguageParam();
  const { t } = useTranslation();
  const [readMore, setReadMore] = useState(false);
  const text = descriptions[lang];
  const lines = text.split('\n').length;
  const limit = 500 + lines;

  const handleToggle = () => {
    readMore ? mixpanelTrack('E.read_more_collapse') : mixpanelTrack('E.read_more_expand');
    setReadMore(!readMore);
  };

  return (
    <div className={`office-description ${extraClasses}`}>
      <div className="fo-display-3 -medium mb-6">{t('office.show.flexibility.description.title')}</div>
      <p className="mb-3">{text.length <= limit || readMore ? text : text.substring(0, limit) + '...'}</p>
      {text.length > limit && (
        <div
          className="cursor-pointer text-1 -medium"
          onClick={() => handleToggle()}
        >
          <span className="text-decoration-underline thick-underline link-underline-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover">
            {t(`office.${readMore ? 'readLess' : 'readMore'}`)}
          </span>
          <SVGIcon iconType={`chevron-${readMore ? 'up' : 'down'}`} />
        </div>
      )}
    </div>
  );
};

export default OfficeDescription;
